<script lang="ts">
	import { DataHandlerDevice, Device } from "luxedo-data"
	import { Reactivity } from "luxedo-reactivity"
	import { ProjectorMenuController } from "../ProjectorMenuController.svelte"
	import { openDeviceColorPicker } from "../device-color-picker/DeviceColorPickerContext"
	import DeviceColorPicker from "../device-color-picker/DeviceColorPicker.svelte"
	import DeviceIcon from "../../../reusable/icons/DeviceIcon.svelte"
	import SelectedDeviceBackground from "./SelectedDevice_Background.svelte"
	import { Responsive } from "responsive"
	import { DeviceStatusPreview } from "luxedo-comps"

	interface Props {
		device: Device
	}

	let { device }: Props = $props()

	$effect.pre(() => {
		Reactivity.useProps(device, ["name", "status", "statusColor"])
	})

	let deviceName = $derived(Reactivity.propOf(device, "name"))
	let deviceStatus = $derived(Reactivity.propOf(device, "status"))
	let deviceStatusColor: string = $derived(Reactivity.propOf(device, "statusColor"))

	let deviceIconElem: SVGElement = $state()
	let isMobile = $derived(Responsive.isMobile)

	/**
	 * Opens the color input component, providing a method to update the device color when changed
	 */
	function openColorInput(e: MouseEvent) {
		e.stopPropagation()

		async function onColorChange(colorIndex: number) {
			device._color = colorIndex
			await DataHandlerDevice.push([device])

			ProjectorMenuController.setDevice(device)
		}

		openDeviceColorPicker(device, deviceIconElem, onColorChange)
	}
</script>

<div class="flex-row device-title-info" class:isMobile>
	<DeviceColorPicker />
	<div class="icon-container">
		<DeviceIcon {device} onclick={openColorInput} bind:iconElem={deviceIconElem} />
		<SelectedDeviceBackground {device} />
	</div>
	<DeviceStatusPreview {device} />
</div>

<style>
	.device-title-info {
		flex-shrink: 1;
		min-width: 0;
	}

	.icon-container {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0 2rem;
	}

	.icon-container :global(svg) {
		width: 4rem;
		height: 4rem;
		z-index: 5;
	}

	.isMobile .icon-container {
		padding: 0 0.5rem;
	}

	.isMobile .icon-container :global(svg) {
		width: 3.5rem;
		height: auto;
	}
</style>
